import { render } from "./CenterList.vue?vue&type=template&id=249935e8&scoped=true"
import script from "./CenterList.vue?vue&type=script&lang=js"
export * from "./CenterList.vue?vue&type=script&lang=js"

import "./CenterList.vue?vue&type=style&index=0&id=249935e8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-249935e8"]])

export default __exports__